module.exports = __webpack_public_path__ + "img/photo-0079.ee9d343d.jpg";